import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import AddressDetail from './AddressDetail';
import OrganisationDetail from './OrganisationDetail';
import ProfileDetail from './ProfileDetail';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;

const Index = () => {
  const { schema } = useEntitySchema(entityNames.ORGANISATION);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.ORGANISATION}
      screenQueryName={EDetailsQueryNames.GetOrganisationDetails}
      entityId={+id}
      title={data => `Organisation #${data?.id}`}
      cancelLink={AppRoutes.OrganisationList}
    >
      <OrganisationDetail schema={schema} />
      <AddressDetail schema={schema} />
      <ProfileDetail schema={schema} />
    </S9CustomEntityFormPage>
  );
};
export default Index;
